// Central API/WebSocket endpoints. Override per-environment with
// REACT_APP_API_BASE / REACT_APP_WS_URL (e.g. in .env.local for dev).
export const API_BASE = (
  process.env.REACT_APP_API_BASE || 'https://api20.easychatdesk.com'
).replace(/\/+$/, '');

export const WS_URL = process.env.REACT_APP_WS_URL || 'wss://api20.easychatdesk.com';
